import * as React from "react";

export const Page = (props: { children: React.ReactNode }) => {
  return (
    <div className="bg-slate-100 text-slate-900 dark:bg-slate-900 dark:text-white">
      <div className="mx-auto px-1 py-8 sm:px-10 md:px-20 lg:px-32 xl:px-[200px]">
        {props.children}
      </div>
    </div>
  );
};

export const TwoColumnView = (props: {
  left: React.ReactNode;
  right?: React.ReactNode;
  /** Content that appears above the feed on mobile, in the right column on desktop */
  rightTop?: React.ReactNode;
  /** Content that appears below the feed on mobile, in the right column on desktop */
  rightBottom?: React.ReactNode;
  style?: React.CSSProperties;
}) => {
  const style = props.style;

  // If using the split right column pattern
  if (props.rightTop || props.rightBottom) {
    return (
      <div className="grid gap-6 lg:grid-cols-[3fr_2fr]" style={style}>
        {/* Main content */}
        <div className="order-2 min-w-0 text-slate-900 dark:text-white lg:order-none">
          {props.left}
        </div>

        {/* Right column wrapper:
            - Mobile: 'contents' makes wrapper invisible, children join grid for ordering
            - Desktop: real block container so rightTop/rightBottom stack together */}
        <div className="contents lg:block lg:space-y-4">
          <div className="order-1 space-y-4 lg:order-none">{props.rightTop}</div>
          <div className="order-3 space-y-4 lg:order-none">{props.rightBottom}</div>
        </div>
      </div>
    );
  }

  // Legacy pattern: single right prop
  return (
    <div className="flex flex-col gap-6 lg:flex-row" style={style}>
      <div className="w-full text-slate-900 dark:text-white lg:w-3/5">
        {props.left}
      </div>
      <div className="flex w-full flex-col gap-4 lg:w-2/5">{props.right}</div>
    </div>
  );
};
